var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-20c7e40d-26c4-47fe-ab56-a7c5fff96f90",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-6fb8eee9-0177-4203-8566-c44b2b655ae8 {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-6fb8eee9-0177-4203-8566-c44b2b655ae8",
    d: "M11.25,22.93c-.37,0-.73-.1-1.06-.3-.6-.37-.96-1.01-.96-1.72v-9.82c0-.71.36-1.35.96-1.72.6-.37,1.34-.4,1.97-.08l9.71,4.91c.68.34,1.11,1.04,1.11,1.8s-.42,1.46-1.11,1.8l-9.71,4.91c-.29.15-.6.22-.91.22ZM11.26,11.08l-.03,9.83,9.73-4.92-9.71-4.91Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.4f1662e4ef85e778dacf16eac2ae2217.svg";
export { ForwardRef as ReactComponent };